
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { useGlobalContext } from '../../GlobalContext';
import { useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import axios from 'axios';
import config from '../../config'; // Path to your config file
import { GetAll } from '../../service/StateService'; // Path to your StateService file
import { GetById, Update } from '../../service/CityService'; // Path to your StateService file

export default function EditState() {
  const { isLoading, setIsLoading, isAppError, setAppError, appErrorMessage, setAppErrorMessage, appErrorTitle, setAppErrorTitle, appErrorMode, setAppErrorMode, appUser } = useGlobalContext();

  // state
  const [stateId, setStateId] = useState('');
  const [states, setStates] = useState([]);
  const [name, setName] = useState('');
  const { id } = useParams();
  const [keyword, setKeyword] = useState('');
  const [status, setStatus] = useState('active');

  //City
  const [city, setCity] = useState({});

  const fetchCityById = async () => {
    try {
      setIsLoading(true);
      var response = await GetById(id);
      console.log("id", response);
      if (response.status === 200) {
        setCity(response.city);
        setName(response.city.name);
        setStateId(response.city.state.id);
        setStatus(response.city.status);
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to load data");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  // fetch state 
  const FetchState = async () => {
    setIsLoading(true);
    try {
      const response = await GetAll(1, 9999, keyword);

      if (response && Array.isArray(response.states)) {
        // Filter only active categories
        const activeStates = response.states.filter(cat => cat.status === "active");
        setStates(activeStates);
      } else {
        setAppError(true);
        setAppErrorMessage('No State Found.');
      }
    } catch (error) {
      setAppError(true);
      setAppErrorMessage('Error loading master data');
      setAppErrorMode('Error');
    } finally {
      setIsLoading(false);
    }
  };


  const saveCity = async (event) => {
    event.preventDefault();

    if (!stateId) {
      setAppError(true);
      setAppErrorMessage("Please select your State.");
      setAppErrorTitle("Validation Error");
      setAppErrorMode("error");
      setIsLoading(false);
      return;
    }

    //check whether the name is filled and atleast have 3 chars
    if (name.length < 3) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Name must be at least 3 characters");
      setAppErrorMode("error");
      return;
    }


    setIsLoading(true);
    try {
      const response = await Update(id, stateId, name, status);
      console.log(response);
      if (response.status === 200) {
        setAppError(true);
        setAppErrorTitle("Action Response");
        setAppErrorMessage(response.message || "City Successfully Updated");
        setAppErrorMode("success");
        window.location.href = "/setting/citys";
      }
      else {
        setAppError(true);
        setAppErrorTitle("Error");
        setAppErrorMessage(response.message || "Failed to edit City. Please try again.");
        setAppErrorMode("error");
      }
    } catch (error) {
      setAppError(true);
      setAppErrorTitle("Error");
      setAppErrorMessage("Failed to add state. Please try again.");
      setAppErrorMode("error");
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    FetchState(); // Call function to fetch states when component mounts
  }, []);

  React.useEffect(() => {
    if (id != null && id != undefined && id != "") {
      fetchCityById();
    }
  }, []);

  return (
    <>
      <Helmet>
        <title> City Manage | {config.appName}</title>
      </Helmet>

      <div className='container'>
        <div className='page'>
          <div className='page-heading'>
            <h1>Edit City</h1>
            <span>
              <Link to="/"> Dashboard </Link> / <Link to="/setting/citys"> City List </Link> / City Manage
            </span>
          </div>
          <div className='page-content'>
            <div className="portal">
              <div className='portal-body'>
                <div className='form'>
                  <form onSubmit={saveCity} encType='multipart/form-data'>
                    <div className='row'>
                      <div className='col-lg-6 col-md-6 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">State</label>
                          <select
                            className="form-control"
                            value={stateId} // Ensure this state is defined
                            onChange={(e) => setStateId(e.target.value)} // Update correctly
                          >
                            <option value="">Select State</option>
                            {states.map(stateOption => (
                              <option key={stateOption.id} value={stateOption.id}>
                                {stateOption.name}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                      <div className='col-lg-6 col-md-6 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Name</label>
                          <input className='form-control' type='text' value={name} onChange={(e) => setName(e.target.value)} />
                        </div>
                      </div>
                      <div className='col-lg-3 col-md-3 col-sm-6 col-12'>
                        <div className="mb-3">
                          <label className="form-label">Status</label>
                          <br></br>
                          <input type='radio' name='status' value="active" onChange={(e) => setStatus(e.target.value)} checked={status === 'active'} /> Active &nbsp;&nbsp;
                          <input type='radio' name='status' value="inactive" onChange={(e) => setStatus(e.target.value)} checked={status === 'inactive'} /> Deactive
                        </div>
                      </div>

                      <div className='clearfix'></div>
                      <div className='col-12 text-end'>
                        <div className="mb-3">
                          <button type='reset' className='btn btn-danger btn-md'> <i className="ri-reset-right-line"></i> Reset </button>

                          &nbsp;&nbsp;
                          <button type='submit' className='btn btn-success btn-md'> <i className="ri-check-fill"></i> Update City </button>

                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </>
  );
}